<template>
  <el-input-number
    v-model="qty"
    size="mini"
    :step="1"
    :min="0"
    :precision="0"
    :controls="false"
    style="width: 64px"
  ></el-input-number>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ColumnInputInQty',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    }
  },
  created () {
    this.tValue = this.lineQty(this.rowId)
  },
  data () {
    return {
      tValue: ''
    }
  },
  computed: {
    ...mapGetters({
      lineQty: 'edit/lineInQty',
      lineProduct: 'edit/lineProduct'
    }),
    qty: {
      get () {
        return this.tValue
      },
      set (val) {
        let isNewBlankLine = !this.lineProduct(this.rowId).name
        // 新建一行空白时，确保输入框内无内容。否则则可以编辑和输入数字
        this.tValue = isNewBlankLine && !val ? undefined : val
        this.handleChange(isNewBlankLine && !val ? undefined : val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setQty: 'edit/setInQty'
    }),
    handleChange (val) {
      this.setQty({ id: this.rowId, qty: val })
      this.bus.$emit(`line-in-qty-changed-${this.rowId}`, val)
    }
  },
  inject: ['bus']
}
</script>
